import style from './Input.module.css'

import { useEffect, useRef, useState } from 'react';

import iconAddGreen from "./icons/icon-add-green.png";
import iconDeleteRed from "./icons/icon-delete-red.png";
import searchImg from "./icons/search.png";


function Input({
    label = "label-input",
    onInput,
    onChange,
    onKeyDown,
    onBlur,
    onFocus,
    validate,
    search = false,
    required = false,
    password = false,
    value = '',
}) {
    const inputId = `input-${Math.random().toString(36).substring(2, 9)}`;

    const [labelDisplay, setLabelDisplay] = useState('')

    function validatePriceInput(e) {
        if (!e.target.value) {
            onInput && onInput(e);
            return;
        };

        e.target.value = e.target.value.replace(",", ".");
        e.target.value = e.target.value.replace(/[^0-9\.]/g, "");

        const priceSplit = e.target.value.split(".");

        if (priceSplit.length > 1) {
            e.target.value = `${priceSplit[0]}.${priceSplit[1].substring(0, 2)}`
        };

        onInput && onInput(e);
    };

    function trims(e) {
        if (!e.target.value) {
            return;
        };
        const reg = new RegExp(/\s+/g);
        e.target.value = e.target.value.trim();
        e.target.value = e.target.value.replace(reg, ' ');
    };

    // useEffect(() => {
    //     let index = 0;
    //     const typeChar = () => {
    //         if (index < label.length) {
    //             setLabelDisplay(label.substring(0, index + 1));
    //             index++;
    //             setTimeout(typeChar, 20);
    //         }
    //     };
    //     typeChar()
    // }, [label])

    return <>
        <div className={style.input}>

            <input
                onChange={(e) => {
                    onChange && onChange(e);
                }}
                onInput={(e) => {
                    if (validate == 'price') {
                        validatePriceInput(e)
                    } else {
                        onInput && onInput(e)
                    }
                }}
                onFocus={(e) => onFocus && onFocus(e)}
                onKeyDown={(e) => { onKeyDown && e.key === 'Enter' && onKeyDown(e) }}
                onBlur={(e) => {
                    trims(e);
                    onBlur && onBlur(e);
                }}
                id={inputId}
                type={password ? "password" : "text"}
                value={value}
                required
            />

            <label htmlFor={inputId}>
                {required && <span className={style.required}>*</span>}
                {label}
            </label>

            {search && <img className={style.searchImg} src={searchImg} />}
        </div>
    </>
}

export { Input }